<template>
    <div>
        <b-row class="content-header">
            <b-col class="content-header-left mb-2" cols="12" md="9">
                <b-row class="breadcrumbs-top">
                    <b-col cols="12">
                        <h2 class="float-left mb-0">Resellers</h2>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="12">
                <b-card>
                    <b-card-text
                        >Voucher codes are usually sent to your email after
                        payment is confirmed.
                        <b-link :to="{ name: 'voucher' }"
                            >Redeem a voucher</b-link
                        >
                        to upgrade your account.
                    </b-card-text>
                </b-card>
            </b-col>
            <b-col md="12" cols="12">
                <b-card title="Important Notice Before Payment">
                    <b-list-group class="list-group-circle text-left">
                        <b-list-group-item>
                            Please review the host status page before making any
                            payment.
                        </b-list-group-item>
                        <b-list-group-item>
                            Daily bandwidth, file size, and file count limits
                            may apply. These limits may change at any time based
                            on third-party host availability, technical
                            conditions, or service policy.
                        </b-list-group-item>
                        <b-list-group-item>
                            Availability may vary by host and by file. Some
                            files on supported hosts may require separate
                            purchase, subscription, verification, or special
                            access on the original host, and may not be
                            accessible through our service.
                        </b-list-group-item>
                        <b-list-group-item>
                            Once a premium key, voucher, or paid plan is
                            activated, it cannot be revoked and payments are
                            non-refundable, except where required by applicable
                            law.
                        </b-list-group-item>
                        <b-list-group-item>
                            If you have any questions before making a payment,
                            please contact us via
                            <a href="https://t.me/ndt258" target="_blank"
                                >Telegram</a
                            >
                            or
                            <a href="mailto:support@leechall.io"
                                >support@leechall.io</a
                            >.
                        </b-list-group-item>
                    </b-list-group>
                </b-card>
            </b-col>
        </b-row>
        <b-row v-if="items.length > 0">
            <b-col md="4" v-for="item in items" :key="item.id">
                <b-card>
                    <a :href="item.url" target="_blank"
                        ><h4 class="text-primary mb-1">{{ item.name }}</h4></a
                    >
                    <b-card-text
                        ><strong>Email:</strong> {{ item.email }}</b-card-text
                    >
                    <b-card-text
                        ><strong>Payment methods:</strong>
                        {{ item.payment_methods }}</b-card-text
                    >
                </b-card>
            </b-col>
        </b-row>
        <p v-else>{{ message }}</p>
    </div>
</template>

<script>
import {
    BRow,
    BCol,
    BCard,
    BCardText,
    BLink,
    BListGroup,
    BListGroupItem,
} from "bootstrap-vue";
export default {
    components: {
        BRow,
        BCol,
        BCard,
        BCardText,
        BLink,
        BListGroup,
        BListGroupItem,
    },
    data() {
        return {
            items: [],
            message: "",
        };
    },
    created() {
        this.$store
            .dispatch("fetchResellers")
            .then((res) => {
                this.items = res.data.data;
                this.message = "We will update soon!";
            })
            .catch((err) => console.log(err));
    },
};
</script>

<style></style>
